import { jsx as _jsx } from "react/jsx-runtime";
import { ContentHashMap } from "../../../core/util/ContentHashMap";
export const Background = (props) => {
    const { children, imgFilePath, style } = props;
    return _jsx("div", { className: 'contact3dbg', style: Object.assign({ flexDirection: 'column', width: '100%', minHeight: '100%', backgroundImage: `url("${ContentHashMap.getContentHashPath(`${imgFilePath}`)}")`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }, style), children: children });
};
//# sourceMappingURL=Background.js.map